(function () {
  if (window.__spidOpenAiAdsLoaded) return;
  window.__spidOpenAiAdsLoaded = true;

  var PIXEL_ID = '4pXy1dZi3vysZBZDHSZ3u4';
  var DEFAULT_CURRENCY = 'USD';
  var state = {
    productViewTracked: false,
    pendingAdds: [],
    subscriberAttached: false
  };

  function bootstrapPixel() {
    if (window.oaiq && window.oaiq.__spidBootstrap) return;

    var queue = window.oaiq || function () {
      queue.q = queue.q || [];
      queue.q.push(arguments);
    };

    queue.q = queue.q || [];
    queue.__spidBootstrap = true;
    window.oaiq = queue;

    if (!document.querySelector('script[data-spid-openai-sdk="true"]')) {
      var sdk = document.createElement('script');
      sdk.async = true;
      sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      sdk.setAttribute('data-spid-openai-sdk', 'true');
      var firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(sdk, firstScript);
      } else {
        (document.head || document.documentElement).appendChild(sdk);
      }
    }

    window.oaiq('init', { pixelId: PIXEL_ID });
  }

  function getCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return DEFAULT_CURRENCY;
  }

  function measure(eventName, eventData, options) {
    if (!window.oaiq) return;
    if (options && Object.keys(options).length) {
      window.oaiq('measure', eventName, eventData, options);
      return;
    }
    window.oaiq('measure', eventName, eventData);
  }

  function safeParseInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizeId(value) {
    if (value === undefined || value === null || value === '') return '';
    return String(value);
  }

  function getProductJson() {
    var node = document.querySelector('script[id^="ProductJson-"]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getVariantFromProduct(productData, variantId) {
    if (!productData || !Array.isArray(productData.variants)) return null;

    var normalizedVariantId = normalizeId(variantId);

    for (var i = 0; i < productData.variants.length; i += 1) {
      if (normalizeId(productData.variants[i].id) === normalizedVariantId) {
        return productData.variants[i];
      }
    }

    return productData.variants[0] || null;
  }

  function getSelectedVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : '';
  }

  function buildContent(details) {
    if (!details) return null;

    var content = {
      id: normalizeId(details.id || details.variantId || details.productId),
      name: details.name || '',
      content_type: details.contentType || 'product'
    };

    if (details.quantity != null) {
      content.quantity = safeParseInt(details.quantity, 1);
    }

    if (Number.isFinite(details.amount)) {
      content.amount = details.amount;
      content.currency = details.currency || getCurrency();
    }

    return content;
  }

  function buildProductDetails(productData, variantId, quantity) {
    if (!productData) return null;

    var variant = getVariantFromProduct(productData, variantId || getSelectedVariantId());
    var amount = variant && Number.isFinite(variant.price) ? variant.price : productData.price;
    var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    var productTitle = productData.title || '';
    var fullTitle = variantTitle ? productTitle + ' - ' + variantTitle : productTitle;

    return {
      id: variant && variant.id ? variant.id : productData.id,
      variantId: variant && variant.id ? variant.id : '',
      productId: productData.id,
      name: fullTitle,
      amount: Number.isFinite(amount) ? amount : undefined,
      currency: getCurrency(),
      quantity: quantity || 1
    };
  }

  function buildFormDetails(form) {
    if (!form) return null;

    var productData = getProductJson();
    var variantId = '';
    var quantity = 1;
    var variantInput = form.querySelector('input[name="id"]');
    var quantityInput = form.querySelector('input[name="quantity"]');

    if (variantInput) variantId = variantInput.value;
    if (quantityInput) quantity = safeParseInt(quantityInput.value, 1);

    if (productData) {
      return buildProductDetails(productData, variantId, quantity);
    }

    var card = form.closest('[data-product-id]') || form.closest('.card-wrapper') || form.closest('.card-product');
    var titleNode = card && (card.querySelector('.card__heading') || card.querySelector('.full-unstyled-link') || card.querySelector('.card-information__text'));
    var title = titleNode ? titleNode.textContent.trim() : document.title;

    return {
      id: variantId,
      variantId: variantId,
      name: title,
      currency: getCurrency(),
      quantity: quantity
    };
  }

  function trackPageViewed() {
    var path = window.location.pathname || '/';
    var search = window.location.search || '';
    var title = document.title || 'Page view';

    measure('page_viewed', {
      type: 'contents',
      contents: [
        {
          id: path + search,
          name: title,
          content_type: 'page'
        }
      ]
    });
  }

  function trackProductViewed() {
    if (state.productViewTracked) return;

    var productData = getProductJson();
    if (!productData) return;

    var details = buildProductDetails(productData, getSelectedVariantId(), 1);
    var content = buildContent(details);
    var payload = {
      type: 'contents',
      contents: content ? [content] : []
    };

    if (details && Number.isFinite(details.amount)) {
      payload.amount = details.amount;
      payload.currency = details.currency;
    }

    measure('contents_viewed', payload);
    state.productViewTracked = true;
  }

  function queuePendingAdd(form) {
    var details = buildFormDetails(form);
    if (!details || !details.id) return;

    state.pendingAdds.push({
      details: details,
      createdAt: Date.now()
    });

    if (state.pendingAdds.length > 10) {
      state.pendingAdds.shift();
    }
  }

  function flushPendingAdd() {
    if (!state.pendingAdds.length) return;

    var pending = state.pendingAdds.shift();
    var details = pending.details;
    var content = buildContent(details);
    var quantity = safeParseInt(details.quantity, 1);
    var payload = {
      type: 'contents',
      contents: content ? [content] : []
    };

    if (Number.isFinite(details.amount)) {
      payload.amount = details.amount * quantity;
      payload.currency = details.currency || getCurrency();
    }

    measure('items_added', payload, {
      event_id: 'items_added_' + Date.now()
    });
  }

  function attachCartSubscriber() {
    if (state.subscriberAttached) return true;

    // Dawn exposes `subscribe` on window, but `PUB_SUB_EVENTS` is a top-level `const`
    // (not a window property), so window.PUB_SUB_EVENTS is undefined. Reference the
    // bare globals via typeof guards (they share the classic-script global scope).
    var sub = (typeof subscribe === 'function') ? subscribe
      : (typeof window.subscribe === 'function') ? window.subscribe : null;
    var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;

    if (!sub || !events || !events.cartUpdate) {
      return false;
    }

    sub(events.cartUpdate, function () {
      flushPendingAdd();
    });

    state.subscriberAttached = true;
    return true;
  }

  function monitorCartSubscriber() {
    if (attachCartSubscriber()) return;

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      if (attachCartSubscriber() || attempts >= 40) {
        window.clearInterval(interval);
      }
    }, 250);
  }

  function bindDomEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      queuePendingAdd(form);
    }, true);
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  function start() {
    bootstrapPixel();
    bindDomEvents();
    monitorCartSubscriber();

    onReady(function () {
      trackPageViewed();
      trackProductViewed();
    });
  }

  // SPID-228: this script loads from the theme, outside the Shopify pixel sandbox,
  // so the consent settings on the OpenAI Ads custom pixel do not apply to it.
  // Gate on marketing consent here instead. SPIDConsent.whenMarketing runs the
  // callback immediately where marketing is already allowed (including regions
  // that require no consent) and otherwise waits for the visitor to grant it.
  if (window.SPIDConsent && typeof window.SPIDConsent.whenMarketing === 'function') {
    window.SPIDConsent.whenMarketing(start);
  } else {
    // consent-mode.liquid missing or failed to run: fail closed rather than track.
    if (window.console && console.warn) {
      console.warn('[SPID] openai-ads-tracking: SPIDConsent unavailable, not tracking.');
    }
  }
})();
